import { createStyles } from 'antd-style';

export const useShipmentPackageListStyles = createStyles(({ token }) => ({
  externalLink: {
    position: 'absolute',
    top: -5,
    right: 16, // To be aligned with assets inventory icon
    color: token.colorPrimary,
  },
}));
